module.exports = __webpack_public_path__ + "img/Network-Building.869bfd5d.png";